import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { changeDrawer, allAppsChangeDrawer } from "Store/appStore/action";
import SideDrawerContainer from "./SideDrawerContainer";
import AccountSettings from "./AccountSettings";
import AllApps from "./../headerComponents/AllApps";
import "./index.less";
/**
 * 侧拉功能区
 */
class SideDrawer extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let {
            isOpen,
            allAppsOpen,
            changeDrawer,
            allAppsChangeDrawer,
            isHome,
            className = ''
        } = this.props;
        // console.log(screen.width)
        const screenWidth = screen.width;
        const allappWidth = screenWidth <= 1440 ? '93%' : '88.88%';
        return (
            <div className={`nc-workbench-drawer ${className}`}>
                {/* 用户设置侧拉容器 */}
                <SideDrawerContainer
                    className="nc-workbench-user-box"
                    open={isOpen}
                    width={364}
                    onChange={changeDrawer}
                >
                    <AccountSettings getDistubInfo={this.props.getDistubInfo} visible={isOpen}/>
                </SideDrawerContainer>
                {/* 全部应用侧拉容器 */}
                <SideDrawerContainer
                    className="nc-workbench-all-app"
                    open={this.props.showAllApp}
                    // width={"82%"}
                    width={allappWidth}
                    placement={"left"}
                    onChange={this.props.changeAllApp}
                >
                    <AllApps
                        navAppInfo={this.props.navAppInfo}
                        showAllApp={this.props.showAllApp}
                        onUserSelectModule={this.props.onUserSelectModule}
                        isHome={isHome}
                    />
                </SideDrawerContainer>
            </div>
        );
    }
}
SideDrawer.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    allAppsOpen: PropTypes.bool.isRequired,
    changeDrawer: PropTypes.func.isRequired,
    allAppsChangeDrawer: PropTypes.func.isRequired
};
export default connect(
    state => ({
        isOpen: state.appData.isOpen,
        allAppsOpen: state.appData.allAppsOpen
    }),
    {
        changeDrawer,
        allAppsChangeDrawer
    }
)(SideDrawer);
